module.exports = __webpack_public_path__ + "static/media/carouselBgHome3.3de0b63c.jpg";